import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  // Start at 14 minutes 39 seconds
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 39);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <span className="font-oswald font-bold text-green-400 text-sm tracking-wider" data-id="element-2">
      {formatTime(timeLeft)}
    </span>;
}